<span routerLink="/">{{ titleService.getTitle() }}</span>

<span class="toolbar-spacer"></span>

<a *ngIf="!small" routerLink="/" routerLinkActive="active" class="active">
   <img class="logo" src="/assets/graphics/logo/logo.png">
</a>

<mat-icon [matMenuTriggerFor]="menu">more_vert</mat-icon>

<mat-menu #menu="matMenu">
  <!--
    <button mat-menu-item routerLink="/privacy-policy" routerLinkActive="active">Privatlivspolitik</button>
    <button mat-menu-item routerLink="/terms-of-use" routerLinkActive="active">Betingelser for brug</button>
  
    <mat-divider></mat-divider>
  -->

  <button mat-menu-item (click)="about()">Om websitet</button>
</mat-menu>
